import "core-js/modules/es6.array.find";
import { orderedBreakpoints } from '../../utils/responsive.es.js';

var getItemsPerPage = function getItemsPerPage(rules, breakpointsState) {
  var currentKey = orderedBreakpoints.find(function (key) {
    return breakpointsState[key] && rules[key];
  });
  return rules[currentKey ? currentKey : "default"];
};

export { getItemsPerPage };